import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn.js';
import { FieldHelp } from './field-help.js';

export interface PageHeaderProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode;
  /** O que a tela faz. Vai para a bolinha "?" ao lado do título (#613). */
  description?: ReactNode;
  /** Slot for breadcrumbs above the title. */
  breadcrumbs?: ReactNode;
  /** Slot for actions on the right (typically buttons). */
  actions?: ReactNode;
}

export const PageHeader = ({
  title,
  description,
  breadcrumbs,
  actions,
  className,
  ...rest
}: PageHeaderProps) => (
  <div className={cn('flex flex-col gap-3 pb-4 sm:gap-4 sm:pb-6', className)} {...rest}>
    {breadcrumbs ? <div className="hidden sm:block">{breadcrumbs}</div> : null}
    <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex min-w-0 items-center gap-2">
        <h1 className="text-xl font-semibold tracking-tight text-fg sm:text-2xl">{title}</h1>
        {description && (
          <FieldHelp title={typeof title === 'string' ? title : 'esta tela'}>
            {description}
          </FieldHelp>
        )}
      </div>
      {actions && (
        <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:items-center">
          {actions}
        </div>
      )}
    </div>
  </div>
);
